import {
    ClearableCheckboxDropdown,
    Table,
} from "dyl-components";
import { Controller, useController, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import {
    Header,
    Pagination,
    Segment,
    Table as SemanticTable,
} from "semantic-ui-react";
import CategoryProductRow from "./CategoryProductRow";

const LIMIT = 25;

const CategoryProducts = ({ onFilter, queryParameters, opportunity_id, hasFilters, onChangePage }) => {
    const { products, isReadingCatalog, count, customer_account_discounts } = useSelector((state) => ({
        products: state.product_catalog.catalog,
        isReadingCatalog: state.product_catalog.isReadingCatalog,
        count: state.product_catalog.count,
        customer_account_discounts: state.product_catalog.catalog_discounts || [],
    }));

    const { control } = useFormContext();

    const { field: masterFilterField } = useController({
        control,
        name: "pricing_schedule"
    });

    const isDyl = useSelector((state) => state.auth.dyl_employee);

    return (
        <>
            <Table>
                <Table.Header>
                    <Table.CollapsibleRow isHeader>
                        <SemanticTable.HeaderCell width={4}>
                            Products
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell>
                            <ClearableCheckboxDropdown
                                text="Type"
                                name="product_type"
                                options={[
                                    {
                                        key: "good",
                                        value: "good",
                                        text: "Good",
                                    },
                                    {
                                        key: "service",
                                        value: "service",
                                        text: "Service",
                                    },
                                ]}
                                onChange={(_, { value }) => {
                                    onFilter(_, {
                                        name: "product_type",
                                        value,
                                    });
                                }}
                                value={queryParameters.product_type}
                                closeOnLoad={true}
                            />
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell>
                            <ClearableCheckboxDropdown
                                text="Pricing Schedule"
                                name="pricing_schedule"
                                options={[
                                    {
                                        key: "one_time",
                                        value: "one_time",
                                        text: "One-time",
                                    },
                                    {
                                        key: "usage_based",
                                        value: "usage_based",
                                        text: "Usage-based",
                                    },
                                    {
                                        key: "recurring",
                                        value: "recurring",
                                        text: "Recurring",
                                    },
                                ]}
                                onChange={(_, { value }) => {
                                    onFilter(_, {
                                        name: "pricing_schedule",
                                        value,
                                    });
                                }}
                                value={queryParameters.pricing_schedule}
                                closeOnLoad={true}
                            />
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell>
                            Price
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell>
                            Max Discount
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell>
                            Max Billing Cycle
                        </SemanticTable.HeaderCell>
                        <SemanticTable.HeaderCell
                            style={{ textAlign: "center" }}
                        >
                            Actions
                        </SemanticTable.HeaderCell>
                    </Table.CollapsibleRow>
                </Table.Header>
                <Table.Body>
                    <Controller
                        control={control}
                        name="cart"
                        render={({ field: { name, value: cart, onChange } }) =>
                            {
                                const allowed_products = cart.filter(product => cart.findIndex(item => item.id === product.id) !== -1).map(product => product.dyl_product_name === "account_balance" ? [product.id] : product.plan_product_ids || []).flat() || [];
                                return !isReadingCatalog &&
                                    products.map((product) => {
                                        const product_discount = customer_account_discounts?.find(discount => discount.product_id === product.id);
                                        const cartIndex = cart.findIndex((item) => item.id === product.id);
                                        const isInCart = cartIndex !== -1;
                                        const price_data = product.price_data;
                                        const isRecurring = price_data?.model?.includes("recurring");
                                        const isVolumeBased = price_data?.model?.includes("volume");
                                        const activeFrequencies = Object.keys(price_data.price).filter(frequency => price_data.price[frequency]?.active);
                                        const selectedPricingSchedule = isRecurring ? masterFilterField?.value || cart[cartIndex]?.pricing_schedule || activeFrequencies[0] : null;
                                        const price = (product.price_data && !product.price_data.model?.includes("volume")) && (isInCart && isRecurring ? `${product.price_data.price[masterFilterField?.value || cart[cartIndex].pricing_schedule]?.price || 0}` : isRecurring ? `${product.price_data.price[selectedPricingSchedule]?.price || 0}` : `${product.price_data.min_price}`);
                                        const required_product_id = product.required_product_id;
                                        const onUpdateCart = () => {
                                            onChange({
                                                target: {
                                                    name,
                                                    value: isInCart
                                                        ? cart.filter((item) => item.id !== product.id && (!item.required_product_id || item.required_product_id !== product.id))
                                                        : (() => {
                                                            const dyl_product_name = product.dyl_product_name;
                                                            const isBalanceProduct = dyl_product_name?.includes("_balance");
                                                            const productToAdd = {
                                                                id: product.id,
                                                                dyl_product_name: dyl_product_name || product.name,
                                                                is_plan: product?.product_type === "plan",
                                                                plan_features: product.plan_features || product.plan_feature_names || [],
                                                                required_product_id,
                                                                plan_product_ids: product?.plan_product_ids,
                                                                quantity: !isVolumeBased ? 1 : (
                                                                    !isRecurring ? price_data.price[0].start : (
                                                                        price_data.price[selectedPricingSchedule]?.volumes[0].start || 1
                                                                    )
                                                                ),
                                                                ...(isRecurring
                                                                    ? { pricing_schedule: masterFilterField?.value || activeFrequencies[0], schedules: activeFrequencies }
                                                                    : {}),
                                                                ...(isBalanceProduct ? { amount: price } : {}),
                                                            };
                                                            if (dyl_product_name !== "account_balance") {
                                                                return [
                                                                    ...cart,
                                                                    productToAdd,
                                                                ].filter(inCart => !isDyl || inCart.id === product.id || !product.plan_product_ids || product.plan_product_ids.length === 0 || product.plan_product_ids.includes(inCart.id))
                                                            }
                                                            return [productToAdd];
                                                        })(),
                                                },
                                            });
                                        };
                                        return (
                                            <CategoryProductRow
                                                key={product.id}
                                                opportunity_id={opportunity_id}
                                                product={product}
                                                product_discount={product_discount}
                                                selectedPricingSchedule={selectedPricingSchedule}
                                                isInCart={isInCart}
                                                onUpdateCart={onUpdateCart}
                                                price={price}
                                                allowed_products={allowed_products} 
                                                hasRequiredProduct={!required_product_id || cart.findIndex(item => item.id === required_product_id) !== -1}
                                                hasProductsInCart={cart.length > 0}
                                            />
                                        );
                                    });
                            }
                        }
                    />
                </Table.Body>
            </Table>
            {isReadingCatalog && <Segment basic loading />}
            {!isReadingCatalog && products.length === 0 && (
                <Segment textAlign="center" basic>
                    <Header as="h3">{hasFilters ? "No Results Found" : "No Products Created"}</Header>
                </Segment>
            )}
            {products.length > 0 && (
                <Segment textAlign="right" basic>
                    <Pagination
                        boundaryRange={0}
                        activePage={queryParameters.page}
                        ellipsisItem={null}
                        siblingRange={2}
                        totalPages={Math.ceil(count / LIMIT)}
                        onPageChange={(_, { activePage }) => {
                            onChangePage(activePage)
                        }}
                        disabled={isReadingCatalog}
                    />
                </Segment>
            )}
        </>
    );
};

export default CategoryProducts;
